/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Marker } from '@googlemaps/markerclusterer'
import { AdvancedMarker } from '@vis.gl/react-google-maps'
import { useCallback } from 'react'
import { MdLocationPin } from 'react-icons/md'

import type { NearbyCustomer } from '../../types/nearby-customers'

export type CustomerMarkerProps = {
  customer: NearbyCustomer
  onClick: (customer: NearbyCustomer) => void
  setMarkerRef: (marker: Marker | null, key: string) => void
}

export const CustomerMarker = (props: CustomerMarkerProps) => {
  const { customer, onClick, setMarkerRef } = props

  const ref = useCallback(
    (marker: google.maps.marker.AdvancedMarkerElement | null) =>
      setMarkerRef(marker, customer.identidade.toString()),
    [setMarkerRef, customer.identidade],
  )

  const handleClick = useCallback(() => {
    onClick(customer)
  }, [onClick, customer])

  return (
    <AdvancedMarker
      title={customer.cliente}
      position={{
        lat: Number(customer.latitude),
        lng: Number(customer.longitude),
      }}
      clickable
      ref={ref}
      onClick={handleClick}
    >
      <span className="marker-clustering-customer ">
        <MdLocationPin size={45} className="text-blue-600" />
      </span>
    </AdvancedMarker>
  )
}
